export const ServicesRoutes = {
    services: (origin: string) => `${origin}/service-now/tickets`,
    servicesFilters: (origin: string) => `${origin}/service-now/filters`,
};
